import * as React from 'react';

import { Button, Drawer, Tag, Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import { ChangeHistoryContent } from '../ChangeHistoryContent';
import { ChangeHistoryFilter } from '../ChangeHistoryFilter';
import { initialChangeHistoryFilter } from '../constants';
import type { ChangeHistoryFilterFormValues } from '../constants';

type ProductData = {
  id: number;
  title: string;
};

type ChangeHistoryModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  productData: ProductData;
};

export const ChangeHistoryModal = ({ isOpen, handleClose, productData }: ChangeHistoryModalProps) => {
  const [filters, setFilters] = React.useState<ChangeHistoryFilterFormValues>(initialChangeHistoryFilter);

  const handleSetFilters = (newFilters: ChangeHistoryFilterFormValues) => {
    setFilters(newFilters);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={handleClose}
      width='100vw'
      title={
        <div className='flex items-center gap-3'>
          <Icon.History size={20} className='text-(--uizz-antd-color-primary)' />
          <div className='flex flex-col gap-0.5'>
            <Typography.Text strong className='text-base leading-tight'>
              Histórico de alterações
            </Typography.Text>
            <div className='flex items-center gap-2'>
              <Tag className='m-0'>{productData.id}</Tag>
              <Typography.Text type='secondary' className='max-w-75 truncate font-normal'>
                {productData.title}
              </Typography.Text>
            </div>
          </div>
        </div>
      }
      footer={
        <div className='flex justify-end'>
          <Button type='text' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <ChangeHistoryFilter setFilters={handleSetFilters} productData={productData} />
      <ChangeHistoryContent filtersForm={filters} productData={productData} />
    </Drawer>
  );
};
